(function() {
var EntryFormOpenSections,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

EntryFormOpenSections = (function() {
  function EntryFormOpenSections() {
    this.remove_id = bind(this.remove_id, this);
    this.add_id = bind(this.add_id, this);
    this.set_ids = bind(this.set_ids, this);
    this.get_ids = bind(this.get_ids, this);
    this.ids_element = bind(this.ids_element, this);
    this.setup_listeners = bind(this.setup_listeners, this);
    this.setup_listeners();
  }

  EntryFormOpenSections.prototype.setup_listeners = function() {
    $(document).on("show.bs.collapse", (function(_this) {
      return function(e) {
        return _this.add_id($(e.target).data("id"));
      };
    })(this));
    return $(document).on("hide.bs.collapse", (function(_this) {
      return function(e) {
        return _this.remove_id($(e.target).data("id"));
      };
    })(this));
  };

  EntryFormOpenSections.prototype.ids_element = function() {
    return $('#event_entry_current_open_section_ids');
  };

  EntryFormOpenSections.prototype.get_ids = function() {
    return this.ids_element().val().split(",").map(function(x) {
      return x.trim();
    }).filter(function(x) {
      return x.length > 0;
    }).map(function(x) {
      return parseInt(x, 10);
    });
  };

  EntryFormOpenSections.prototype.set_ids = function(ids) {
    return this.ids_element().val(ids.join(","));
  };

  EntryFormOpenSections.prototype.add_id = function(id) {
    var ids;
    ids = this.get_ids();
    if (!ids.includes(id)) {
      ids.push(id);
    }
    return this.set_ids(ids);
  };

  EntryFormOpenSections.prototype.remove_id = function(id) {
    var ids, x;
    ids = (function() {
      var i, len, ref, results;
      ref = this.get_ids();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        x = ref[i];
        if (x !== String(id)) {
          results.push(x);
        }
      }
      return results;
    }).call(this);
    return this.set_ids(ids);
  };

  return EntryFormOpenSections;

})();

window.alpha_oms.oms_entry_form_open_sections_constructor = EntryFormOpenSections;

}).call(window);
